module.exports = __webpack_public_path__ + "img/20191216161059360截图20191216105004373.32fe96ec.jpg";